<template>
  <cus-dialog>
    <template v-slot:body>
      <div style="padding: 0 4px">
        <div v-for="(item, index) in copyList" :key="index" class="add-on-item">
          <cus-button
            color="blue"
            topIcon="dash-lg"
            buttonClass="icon"
            :disabled="item.amount === 1"
            @click="item.amount -= 1"
          ></cus-button>
          <div class="item-info">
            <p>{{ item.label }}：</p>
            <p>{{ item.amount }}</p>
          </div>
          <cus-button color="blue" topIcon="plus-lg" buttonClass="icon" @click="item.amount += 1"></cus-button>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="確定" color="blue" :width="50" @click="submit(copyList)"></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { inject, reactive } from 'vue';
export default {
  name: 'edit-add-on',
  setup() {
    //接受provide值
    const close = inject('close');
    const submit = inject('submit');
    const { list } = inject('list');
    const copyList = reactive(JSON.parse(JSON.stringify(list)));

    return {
      close,
      submit,
      copyList,
    };
  },
};
</script>
<style lang="scss" scoped>
.add-on-item {
  @include flex-between-center;
  margin: 8px 0;
  :deep(.icon) {
    width: 80px !important;
    -webkit-text-stroke: 0.5px white;
  }
  .item-info {
    width: 240px;
    display: grid;
    grid-template-columns: 65% auto;
    align-items: center;
    p:nth-of-type(1) {
      font-size: 2.4rem;
      color: $color-blue;
    }
    p:nth-of-type(2) {
      font-size: 4.2rem;
      color: $color-green;
    }
  }
}
</style>
